const initialState = {
  fetching: false,
};

export default function assessmentReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'ASSESSMENT_FETCHING':
      return { ...currentState, fetching: true };
    case 'ASSESSMENT_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
